var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'h-6',
    'transition-all',
    'duration-300',
    'ease-in-out',
    'min-w-[20px]',
    {
      'pe-1': !_setup.isHidden || _setup.isPeeking,
      'pe-0.5': _setup.isHidden && !_setup.isPeeking,
    },
    'ps-0.5',
    'bg-dark-text-200',
    'backdrop-blur-10',
    'rounded-xl',
    'text-light-text-100',
    'text-body-small',
    'flex',
    'items-center',
    'select-none',
    'overflow-hidden',
  ],style:({
    'max-width': !_setup.isHidden || _setup.isPeeking ? `${_setup.props.canvasWidth}px` : '0px',
  }),on:{"pointerover":_setup.peek}},[_c('div',{class:['w-5', 'h-5', 'rounded-full', 'bg-dark-ui-100', 'flex', 'items-center', 'justify-center', 'shrink-0']},[_c(_setup.OzLoadingSpinnerWithCheckmark,{class:['shrink-0'],attrs:{"progress":_setup.props.progress,"size":12,"color":'white',"is-checkmark":_setup.isUploadDone,"spinner-label":_setup.progressingText,"checkmark-label":_setup.doneText},on:{"transformed-to-checkmark":_setup.handleTransformedToCheckmark}})],1),_vm._v(" "),_c('Transition',{attrs:{"leave-active-class":"transition-all delay-100 duration-50 ease-in motion-reduce:transition-none","leave-to-class":"opacity-0 max-w-0","leave-class":"max-w-6xl"}},[(!_setup.isHidden || _setup.isPeeking)?_c('div',{staticClass:"ms-2"},[(!_setup.isTransformedToCheckmark)?_c('span',{staticClass:"truncate w-full"},[_vm._v(_vm._s(_setup.progressingText))]):_c('span',{staticClass:"truncate w-full"},[_vm._v(_vm._s(_setup.doneText))])]):_vm._e()]),_vm._v(" "),_c('div',{class:{
      'w-0.5': !_setup.isTransformedToCheckmark,
      'animate-to-w-2 w-2': _setup.isTransformedToCheckmark && (!_setup.isHidden || _setup.isPeeking),
      'w-2': _setup.isHidden && !_setup.isPeeking,
    }}),_vm._v(" "),_c('Transition',{attrs:{"leave-active-class":"transition-all duration-500 ease-in motion-reduce:transition-none","leave-to-class":"opacity-0 max-w-0","leave-class":"max-w-6xl"}},[(!_setup.isTransformedToCheckmark)?_c(_setup.OzPlainButton,{attrs:{"dark-mode":true,"text":_setup.__('Cancel'),"color-scheme":_setup.OzPlainButtonColorScheme.Secondary,"size-preset":_setup.OzPlainButtonSizePreset.H24px},on:{"click":function($event){return _setup.emit('cancel')}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }